import { Analytics } from '@cobliteam/analytics';
import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Tag from '@cobliteam/ui/components/Tag';
import Icon from '@cobliteam/ui/icons';

const normalizeChannel = (channel: string) => channel.replace(/^#/, '');

const getSlackUrl = (channel: string) => {
  return `https://cobli.slack.com/app_redirect?channel=${normalizeChannel(channel)}`;
};

const InfoCobli = () => {
  const { sidebar, environment } = useDashboard();
  const { t } = useTranslation('ui-business');
  const user = useUser().getUser();
  const isCobler = user?.role === 'cobler';

  if (!(isCobler || environment.isDev)) return null;

  const teamName = sidebar.route?.team?.name;
  const teamChannels = sidebar.route?.team?.channels;
  const slackHelp = teamChannels?.['slack-help'];
  const slackChannelName = slackHelp ? normalizeChannel(slackHelp) : undefined;
  const openSlackHelp = () => {
    if (!slackHelp) return;

    Analytics.track('PageFooter - Click - OpenSlackHelp', {
      teamName,
      channel: slackChannelName,
    });
    window.open(getSlackUrl(slackHelp), '_blank', 'noopener,noreferrer');
  };

  if (!teamName) return null;

  return (
    <div className='flex w-full flex-wrap items-center justify-center gap-3 border-gray-6 border-t bg-gray-2 px-6 py-3'>
      <Tag label={t('page_footer.owner_info.squad', { team: teamName })} icon={<Icon name='users' />} variant='surface' color='default' className='h-7 px-2.5' />

      {slackHelp && (
        <Button
          variant='surface'
          color='sky'
          size='sm'
          startIcon={<Icon name='message-circle' />}
          onClick={openSlackHelp}
          aria-label={t('page_footer.owner_info.open_slack_channel', { channel: slackChannelName })}
        >
          {t('page_footer.owner_info.help_tech_slack')}
        </Button>
      )}
    </div>
  );
};

export default InfoCobli;
